var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9091 26.2727C30.9091 26.2727 30.9091 5.40909 30.9091 4.63636C30.9091 3.86364 30.1364 3.09091 29.3636 3.09091H4.63636C3.86364 3.09091 3.09091 3.86364 3.09091 4.63636V26.2727L13.9091 13.9091L18.5455 20.0909L21.6364 17L30.9091 26.2727ZM27.625 8.5C27.625 10.2604 26.1979 11.6875 24.4375 11.6875C22.6771 11.6875 21.25 10.2604 21.25 8.5C21.25 6.73959 22.6771 5.3125 24.4375 5.3125C26.1979 5.3125 27.625 6.73959 27.625 8.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09091 0C1.52621 0 0 1.54545 0 3.1875C0 3.1875 0 29.3443 0 30.9091C0 32.4739 1.54545 34 3.09091 34H30.9091C32.4545 34 34 32.4739 34 30.9091C34 29.3443 34 3.09091 34 3.09091C34 1.54545 32.4738 0 30.9091 0H3.09091ZM1.54545 3.09091C1.54545 2.31818 2.31818 1.54545 3.09091 1.54545H30.9091C31.6818 1.54545 32.4545 2.31818 32.4545 3.09091V30.9091C32.4545 31.6818 31.6818 32.4545 30.9091 32.4545H3.09091C2.31818 32.4545 1.54545 31.6818 1.54545 30.9091V3.09091Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.c8d99021e12691ceb00a2141c51d83ca.svg";
export { ForwardRef as ReactComponent };